// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'currency';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M6.192 6.192a5.623 5.623 0 0 0 5.616 5.616c3.096 0 5.616-2.52 5.616-5.616S14.904.576 11.808.576a5.623 5.623 0 0 0-5.616 5.616zm-1.44 4.392c0 .432.216.792.648.936l1.512.648c.504.216.792.792.576 1.296-.144.36-.504.648-.936.648H5.04m1.152 1.08V14.04' />
    <path d='M3.96 6.624C1.08 7.848-.216 11.16 1.008 14.04c1.224 2.88 4.536 4.176 7.416 2.952a5.896 5.896 0 0 0 2.952-2.952M12.96 3.96h-1.512a.984.984 0 0 0-1.008 1.008c0 .432.216.792.648.936l1.512.576c.504.216.792.792.576 1.296-.144.36-.504.648-.936.648h-1.512m1.08-4.464V2.808m0 6.768V8.424' />
  </g>
);

export const viewBox = '0 0 18 18';
